module.exports = __webpack_public_path__ + "1068c74ae48d220d83b694a7d3c326aa.pdf";